export default "__VITE_ASSET__CzhgbVRa__"